export default {
  social: [
    'facebook',
    'snapchat',
    'pinterest',
    'twitter',
    'instagram',
    'messenger',
    'gmail',
    'whatsapp',
    'google',
  ],
  audience: [
    'salesforce',
    'analytics',
    'tradedesk',
    'dcm',
    'adobe',
    'facebook',
    'snapchat',
    'pinterest',
    'twitter'
  ],
  commerce: [
    'amazon',
    'target',
    'walmart',
    'kroger',
    'instacart',
    'ulta',
    'sephora',
    'walgreens',
    'cvs'
  ]
}



// WEBPACK FOOTER //
// ./client/components/site/MikMakAttach/logos.js